module.exports = __webpack_public_path__ + "img/gif7.032a7b58.gif";